import { http } from '../utils';
import config from '~/config';

export type PrefetchData = {
  imageUrl: string;
  shareImageUrl?: string;
  language: string;
  code?: number;
  message?: string;
  isInit?: boolean;
};

const defaultData: PrefetchData = {
  imageUrl: '',
  language: '',
  isInit: false
};

type FuncPreFetch = (context: any) => Promise<PrefetchData>;

type FuncQueryShareInfo = (key: string, isSandbox?: boolean) => Promise<PrefetchData>;

export const sandboxStr = ['sandbox', 'localhost'];

// 获取key对应的内容
export const queryShareInfo: FuncQueryShareInfo = async (key: string, isSandbox = false) => {
  const host = isSandbox ? 'https://act-sandbox.vasnssdk.com' : 'https://www.marvelsnap.com';
  const originResult = await http.post(`${host}/act/${config.appId}/process/exec/v2`, {
    body: {
      front_params: JSON.stringify({ key }),
      login_type: 'no_login',
      channel_app_id: String(config.appId),
      activity_id: String(config.actId),
      process_id: '7312278496405969670'
    }
  });
  const result = await originResult.json();
  const { code, data = {} } = result;
  if (code !== 0) {
    return {
      ...defaultData,
      code: -2
    };
  }
  const { process_exec_code, copywriting } = data;
  if (process_exec_code !== 0) {
    return {
      ...defaultData,
      code: -3,
      message: copywriting
    };
  }
  const value = data?.get?.value?.value || '';
  const valueArr = value.split(',');
  if (valueArr?.length < 2) {
    return {
      ...defaultData,
      code: -4,
      message: `array length or type error: ${valueArr.length}/${valueArr[0]}`
    };
  }
  const imageUrl = valueArr[0] || '';
  const language = valueArr[1] || '';
  const shareImageUrl = valueArr[2] || '';

  return {
    language,
    imageUrl,
    shareImageUrl
  };
};

// 预取数据
export const prefetchData: FuncPreFetch = async (context) => {
  const data = defaultData;
  try {
    let q: Record<string, string> = {};
    let isSandbox = false;
    try {
      // 判断是否沙箱
      const host = context?.request?.host || context?.request?.url || '';
      isSandbox = sandboxStr.some((str) => host.includes(str));
    } catch (_) {}
    if (context.request) {
      // 获取query
      q = context.request.query || {};
    }
    if (!q.id) {
      return {
        ...defaultData,
        isInit: true,
        code: -1
      };
    }
    const content = await queryShareInfo(q.id, isSandbox);
    return {
      ...content,
      isInit: true
    };
  } catch (e) {
    data.code = -9999;
    data.message = e.message;
    data.isInit = true;
  }

  return data;
};
